import { useMediaQuery } from 'react-responsive';

export const useIsMobile = (breakpoint: number = 768): boolean => {
  const isMobile = useMediaQuery({ maxWidth: breakpoint });
  return isMobile;
}